import React from 'react'
import PropTypes from 'prop-types'
import styles from './style.module.scss'

import CustomFormGroup from '@shared/components/customForm/customFormGroup'
import CustomInput from '@shared/components/customForm/customInput'

const SearchFilter = ({ formStyles, mobilefilter, handleSearch }) => {
  return (
    <CustomFormGroup
      controlId="search"
      className={`${formStyles?.formGroup} ${mobilefilter?.formGroup} ${styles?.formGroup} ${styles.searchFilter} flex-grow-1`}
    >
      <CustomInput
        type="input"
        placeholder={'Search by team, series'}
        className={`${formStyles?.formControl} d-flex`}
        onChange={(e) => {
          handleSearch(e.target.value)
        }}
      />
    </CustomFormGroup>
  )
}

SearchFilter.propTypes = {
  formStyles: PropTypes.any,
  mobilefilter: PropTypes.any,
  handleSearch: PropTypes.func
}

export default SearchFilter
